import cookie from "vue-cookie";

let cookieCacheSet = (key, value, expire) => {
    let exp = isNaN(parseInt(expire)) ? 86400 : parseInt(expire);
    let t = timeStamp();
    let val = { value: value, expire: exp + t };
    cookie.set(key, JSON.stringify(val));
};

let cookieCacheGet = key => {
    let val = cookie.get(key);
    if (!val || val == "undefined") {
        return "";
    }
    let data = JSON.parse(val);
    if (data.expire < timeStamp()) {
        cookie.set(key, "");
        return "";
    }
    return data.value;
};

let cookieCacheDel = key => {
    cookie.delete(key);
};

let timeStamp = () => {
    return Date.parse(new Date()) / 1000;
};

export { cookieCacheSet, cookieCacheGet, cookieCacheDel };



// WEBPACK FOOTER //
// ./src/tool/cache.js